import { useEffect } from "react";
import { ErrorBoundary as ReactErrorBoundary, ErrorBoundaryPropsWithComponent } from "react-error-boundary";

const ErrorFallback: ErrorBoundaryPropsWithComponent["FallbackComponent"] = ({ resetErrorBoundary }) => {
  useEffect(() => {
    resetErrorBoundary();
  }, []);
  return null;
};

const SilentFallback: ErrorBoundaryPropsWithComponent["FallbackComponent"] = () => null;

/**
 * autoReset retries the render straight away, which is what the map internals
 * want for a transient tile error. Set it false where a failure must simply
 * cost us the map: retrying a throw that recurs on every render would spin.
 */
export const MapErrorBoundary: RFC<{ autoReset?: boolean }> = ({ children, autoReset = true }) => {
  return (
    <ReactErrorBoundary FallbackComponent={autoReset ? ErrorFallback : SilentFallback}>{children}</ReactErrorBoundary>
  );
};

MapErrorBoundary.displayName = MapErrorBoundary.name;
